import { Directive, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CdkConnectedOverlay } from '@angular/cdk/overlay';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[cdkConnectedOverlayDelay]',
  standalone: false,
})
export class CdkConnectedOverlayDelayDirective implements OnChanges {
  @Input() public cdkConnectedOverlayOpen: boolean;

  public constructor(private readonly cdkConnectedOverlay: CdkConnectedOverlay) {}

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.cdkConnectedOverlayOpen) {
      (this.cdkConnectedOverlay?.overlayRef?.overlayElement?.firstChild as HTMLElement)?.classList?.add('cdk-overlay-delay');
    }
  }
}
